import { api, withUserContext } from './Api';
import { CreateUserType, UserType } from '@/types/UserType';

async function getAll(query?: any, userClientId?: string) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .get<UserType[]>('/v1/users', { ...config, params: query })
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

async function getByTag(userTag: string, userClientId?: string) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .get<UserType>(`/v1/users/tag/${userTag}`, config)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

async function getByEmail(email: string, userClientId?: string) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .get<UserType>(`/v1/users/email/${encodeURIComponent(email)}`, config)
    .then(res => res.data)
    .catch(() => {
      // Se não encontrar por email, tenta por query
      return api
        .get<UserType[]>('/v1/users', { ...config, params: { email } })
        .then(res => {
          if (res.data && res.data.length > 0) {
            return res.data[0];
          }
          throw new Error('User not found');
        });
    });
}

// getBillsByUserTag moved to PaymentsService.getBills() for better organization

async function create(user: CreateUserType, userClientId?: string) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .post<UserType>('/v1/users', user, config)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

async function update(
  userId: string,
  user: Partial<UserType>,
  userClientId?: string
) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .put<UserType>(`/v1/users/${userId}`, user, config)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

async function remove(userId: string, userClientId?: string) {
  const config = userClientId ? withUserContext(userClientId) : {};

  return await api
    .delete(`/v1/users/${userId}`, config)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

export const UsersService = {
  getAll,
  getByTag,
  getByEmail,
  create,
  update,
  remove,
};
